import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import {
  STAFF_PAGE_HEADER_NAV,
  STAFF_PAGE_HEADER_NAV_MAP,
  STAFF_PAGE_HEADER_PATH_MAP,
} from './StaffPageHeaderConstants';

export function useStaffPageHeaderIsActive() {
  const location = useLocation();

  const isActive = useCallback(
    (type: keyof typeof STAFF_PAGE_HEADER_NAV_MAP) =>
      Boolean(
        location &&
          type !== 'HOME' &&
          (location.pathname.includes(STAFF_PAGE_HEADER_PATH_MAP[type]) ||
            (type === 'QUEUES' && location.pathname.includes('staff/queues'))),
      ), // non-staff: grad program special-cased
    [location],
  );

  const navInactive = STAFF_PAGE_HEADER_NAV.every((t) => !isActive(t));

  return { isActive, navInactive };
}
